import { render, staticRenderFns } from "./default.vue?vue&type=template&id=f4558e34&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/opt/build/repo/storefront/components/legacy/page/page-header.vue').default,PagePromoBanners: require('/opt/build/repo/storefront/components/legacy/page/page-promo-banners.vue').default,PageMessages: require('/opt/build/repo/storefront/components/legacy/page/page-messages.vue').default,LoadingOverlay: require('/opt/build/repo/storefront/components/legacy/global/loading-overlay.vue').default,PageFooter: require('/opt/build/repo/storefront/components/molecules/Page/PageFooter.vue').default,PageSubFooter: require('/opt/build/repo/storefront/components/molecules/Page/PageSubFooter.vue').default,CookieSidebar: require('/opt/build/repo/storefront/components/organisms/Sidebar/CookieSidebar.vue').default,AdrollPixel: require('/opt/build/repo/storefront/components/legacy/global/adroll-pixel.vue').default,LocalisationSidebar: require('/opt/build/repo/storefront/components/organisms/Sidebar/LocalisationSidebar.vue').default,DynamicSidebar: require('/opt/build/repo/storefront/components/organisms/Sidebar/DynamicSidebar.vue').default})
